import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import SEO from "@/components/SEO";
import { Mail, Phone, MapPin, Send } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Mesajınız alındı. En kısa sürede dönüş yapacağız.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <>
      <SEO title="İletişim" description="Wünberg Paint & Coating ile iletişime geçin: bayilik, sipariş ve ürün bilgileri." />
      <section className="pt-32 pb-12 border-b border-white/10">
        <div className="wb-container">
          <div className="wb-overline">İletişim</div>
          <h1 className="wb-h1 mt-3">Bize ulaşın.</h1>
          <p className="wb-body mt-5 max-w-2xl">
            Ürünler, bayilik ve özel projeler hakkında her türlü sorunuz için bize yazın.
          </p>
        </div>
      </section>

      <section className="wb-section">
        <div className="wb-container grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2 space-y-8">
            <div>
              <div className="wb-overline mb-3">Doğrudan İletişim</div>
              <div className="space-y-4 mt-4">
                <div className="flex items-center gap-3 text-sm">
                  <Mail className="text-[#d4af37]" size={18} /> info@cebitech.com.tr
                </div>
                <div className="flex items-center gap-3 text-sm">
                  <Phone className="text-[#d4af37]" size={18} /> 0544 222 6 1 07
                </div>
                <div className="flex items-start gap-3 text-sm">
                  <MapPin className="text-[#d4af37] mt-0.5" size={18} />
                  <div>
                    Yeşilbahçe Mah. 1428 Sokak No: 48/A<br />
                    Muratpaşa / ANTALYA
                  </div>
                </div>
              </div>
            </div>

            <div className="wb-card p-6">
              <div className="wb-overline">Şirket Bilgileri</div>
              <div className="text-sm mt-4 space-y-2">
                <div className="font-serif text-base">
                  Çebi Havacılık Turizm Org. Bil. Teks. İnş. Res. Oto Eml. San. ve Tic. Ltd. Şti.
                </div>
                <div className="text-[#a0aabf] text-xs space-y-1 mt-3">
                  <div><span className="text-[#d4af37]">Vergi Dairesi:</span> Antalya Kurumlar VD</div>
                  <div><span className="text-[#d4af37]">Vergi No:</span> 2330655311</div>
                </div>
              </div>
            </div>

            <div className="wb-card p-6">
              <div className="font-serif text-lg">Çalışma Saatleri</div>
              <div className="text-sm text-[#a0aabf] mt-3 space-y-1">
                <div>Pazartesi – Cuma: 09:00 – 18:00</div>
                <div>Cumartesi: 10:00 – 14:00</div>
                <div>Pazar: Kapalı</div>
              </div>
            </div>
          </div>

          <form onSubmit={submit} className="lg:col-span-3 wb-card p-8 space-y-4" data-testid="contact-form">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input className="wb-input" placeholder="Adınız Soyadınız" required value={form.name} onChange={set("name")} data-testid="contact-input-name" />
              <input className="wb-input" type="email" placeholder="E-posta" required value={form.email} onChange={set("email")} data-testid="contact-input-email" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input className="wb-input" placeholder="Telefon (opsiyonel)" value={form.phone} onChange={set("phone")} data-testid="contact-input-phone" />
              <input className="wb-input" placeholder="Konu" required value={form.subject} onChange={set("subject")} data-testid="contact-input-subject" />
            </div>
            <textarea className="wb-input min-h-[180px] resize-none" placeholder="Mesajınız" required value={form.message} onChange={set("message")} data-testid="contact-input-message" />
            <button type="submit" disabled={loading} className="wb-btn-primary w-full sm:w-auto" data-testid="contact-submit">
              {loading ? "Gönderiliyor..." : <>Mesajı Gönder <Send size={16} /></>}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
